import { topicItems } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">大家都在关注这些内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full cursor-pointer transition-colors duration-200 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200/60"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-200">{item.name}</span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}